export enum CreateCommunityPermissionFeatureName {
  COMMUNITY_PUBLIC = 'COMMUNITY_PUBLIC'
}
